import type { ReactNode } from "react";

import { TextHighlightArea, type TextHighlightSurface } from "@asurion-core/expert-workspace-timeline";
import { useFeatures, type WorkspaceFeatures } from "@expert/features";

import { usePartnerConfig } from "@/partner/usePartnerConfig";
import { useLogger } from "@/sdk/logging/LoggerProvider";

interface Props {
    surface: TextHighlightSurface;
    children: ReactNode;
}

/** Highlight-to-copy / "Tell me more" for workspace panels outside the timeline (`isTextHighlightAssistEnabled`). */
export function AssistTextHighlight({ surface, children }: Props) {
    const logger = useLogger({ rootModule: "AssistTextHighlight", supportTeam: "solve", surface });
    const { gaiaPayloadProps } = usePartnerConfig();
    const {
        features: { isTextHighlightAssistEnabled },
    } = useFeatures<WorkspaceFeatures>();

    return (
        <TextHighlightArea
            isEnabled={isTextHighlightAssistEnabled}
            surface={surface}
            logger={logger}
            gaiaPayloadProps={gaiaPayloadProps}
        >
            {children}
        </TextHighlightArea>
    );
}
